import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pagina-welcome',
  templateUrl: './pagina-welcome.component.html',
  styleUrls: ['./pagina-welcome.component.scss']
})
export class PaginaWelcomeComponent implements OnInit {

  constructor() { }

  showSplash = true;

  ngOnInit(): void {

      setTimeout(() => {
        this.showSplash = !this.showSplash;
        // console.log("[PaginaWelcomeComponent]");
      }, 3000);
      
  }

}
